'use client';

// INVARIANT(scriptera): СЦЕНА-ПРИМЕР НАРИСОВАНА В ДВУХ МЕСТАХ — веб (apps/web: components/auth/app-onboarding.tsx,
// components/auth/onboarding.css, components/mock-phone.{tsx,css}, app/[locale]/wizard-scene/[scene]/*,
// lib/scene-script.ts) и iOS (scriptera-app: ios/App/App/Kit/Scenes/*). Правишь вид, шаг, текст-раскладку, тайминг,
// цвет или размер — правь ОБА места тем же днём и сверяй кадры склейкой «веб | iOS» (~/ops/native-scenes). Причина:
// владелец 26.10.2026 — сцены в приложении нативные, «пиксель в пиксель». Канон: ~/projects/NATIVE-SCENES-TZ.md,
// docs/HOW-IT-WORKS.md §«Сцены-примеры».

// ОБЩИЙ хром нарисованного телефона (владелец 27.08: «чтоб это было общим кодом»):
// статус-бар, залитый самолёт, силуэт Инстаграма и фото-аватар Дарьи живут ЗДЕСЬ
// одним экземпляром — их делят мини-тур приложения (auth/app-onboarding) и сцены
// лендинга (landing2/scenes). Правишь вид — правь тут, не копиями.
import { useEffect, useState } from 'react';

import './mock-phone.css';

/** Статус-бар: ЖИВОЕ время пользователя (владелец 28.08) и значки по центрам
 *  «ушей» вокруг островка, как настоящий iPhone. Цвет наследуется (currentColor).
 *  До маунта время пустое — сервер и клиент рисуют одинаково, гидрация не рвётся. */
export function PhoneStatus() {
  const [hm, setHm] = useState('');
  useEffect(() => {
    const upd = () => {
      const d = new Date();
      setHm(`${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}`);
    };
    upd();
    const id = setInterval(upd, 30_000);
    return () => clearInterval(id);
  }, []);
  return (
    <span className="mps" aria-hidden>
      <b>{hm}</b>
      <span className="mps-r">
        <svg viewBox="0 0 20 13" width="18" height="12">
          <rect x="0" y="8" width="3.4" height="5" rx="1.1" />
          <rect x="5.4" y="5.4" width="3.4" height="7.6" rx="1.1" />
          <rect x="10.8" y="2.7" width="3.4" height="10.3" rx="1.1" />
          <rect x="16.2" y="0" width="3.4" height="13" rx="1.1" />
        </svg>
        <svg viewBox="0 0 18 14" width="16" height="12">
          <circle cx="9" cy="11.7" r="1.7" />
          <path
            d="M5.6 8.4a4.6 4.6 0 0 1 6.8 0"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
          <path
            d="M2.6 5.2a7.6 7.6 0 0 1 12.8 0"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.1"
            strokeLinecap="round"
          />
        </svg>
        <svg viewBox="0 0 27 14" width="26" height="13">
          <rect x="0" y="0" width="24" height="14" rx="4.4" />
          <path d="M25 4.6v4.8a2.5 2.5 0 0 0 0-4.8z" opacity="0.4" />
          <text x="12" y="10.4" textAnchor="middle" className="mps-n">
            100
          </text>
        </svg>
      </span>
    </span>
  );
}

/** Залитый самолёт отправки — как в настоящем директе: короткий дротик носом
 *  ВВЕРХ-ВПРАВО со скруглёнными углами (зум пилюли со скрина владельца 28.08). */
export function PlaneGlyph({ size }: { size: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden>
      <g transform="rotate(-42 12 12)">
        <path
          d="M4.4 19.9 20.4 13a1.1 1.1 0 0 0 0-2L4.4 4.1a1 1 0 0 0-1.36 1.16L4.6 11l8.4 1-8.4 1-1.56 5.74a1 1 0 0 0 1.36 1.16z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

/** Силуэт Инстаграма (тот же путь, что на герое) — стоит в композере вместо камеры.
 *  brand — их фирменный градиент (шапка «Комментарии», владелец 28.08). */
export function IgGlyph({ size, className, brand }: { size: number; className?: string; brand?: boolean }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width={size} height={size} aria-hidden>
      {brand ? (
        <defs>
          <linearGradient id="mp-ig-grad" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0" stopColor="#fdc468" />
            <stop offset="0.5" stopColor="#e6336b" />
            <stop offset="1" stopColor="#7237c8" />
          </linearGradient>
        </defs>
      ) : null}
      <path
        d="M7.4 2.6h9.2a4.8 4.8 0 0 1 4.8 4.8v9.2a4.8 4.8 0 0 1-4.8 4.8H7.4a4.8 4.8 0 0 1-4.8-4.8V7.4a4.8 4.8 0 0 1 4.8-4.8zm4.6 4.6a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6zm0 2.2a2.6 2.6 0 1 1 0 5.2 2.6 2.6 0 0 1 0-5.2zm5.3-3.1a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4z"
        fill={brand ? 'url(#mp-ig-grad)' : 'currentColor'}
      />
    </svg>
  );
}

/** Значок Телеграма — фирменный синий кружок с самолётом (владелец 24.10.2026: в шапке телеграм-сцен справа,
 *  как значок Инстаграма у инстаграм-сцен). Чужой фирменный цвет — не наша палитра, не перекрашивать. */
export function TgGlyph({ size, className }: { size: number; className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width={size} height={size} aria-hidden>
      <defs>
        <linearGradient id="mp-tg-grad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#2aabee" />
          <stop offset="1" stopColor="#229ed9" />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="12" fill="url(#mp-tg-grad)" />
      <path
        d="M5.4 11.6l11.3-4.4c.5-.2 1 .1.8.9l-1.9 9c-.1.7-.6.8-1.1.5l-3-2.2-1.4 1.4c-.2.2-.3.3-.6.3l.2-3 5.4-4.9c.2-.2 0-.3-.3-.2l-6.7 4.2-2.9-.9c-.6-.2-.6-.6.2-.7z"
        fill="#ffffff"
      />
    </svg>
  );
}

/** Фото-аватар Дарьи (вторая сцена тура): рисованный портрет, не серый круг. */
export function MarinaAva({ size }: { size: number }) {
  return (
    <svg className="mps-round" viewBox="0 0 40 40" width={size} height={size} aria-hidden>
      <circle cx="20" cy="20" r="20" fill="#f3ddc9" />
      <circle cx="20" cy="9" r="5" fill="#4c3626" />
      <path d="M9 24c0-8 4.5-13 11-13s11 5 11 13z" fill="#5b4233" />
      <circle cx="20" cy="19" r="7.2" fill="#f2b98c" />
      <path d="M7 40c1-8 6-12 13-12s12 4 13 12z" fill="#31a4b6" />
    </svg>
  );
}
